import { _Button as ReactButton } from "@certn/cascadia-react/components/button/_Button";
import { memo, useState } from "react";

import { CascadiaInternalButtonProps } from "./types";

export const _Button = memo((props: CascadiaInternalButtonProps) => {
  const [isPending, setIsPending] = useState(false);

  async function handlePress() {
    if (!props.onPress || props.isDisabled || isPending) {
      return;
    }

    try {
      setIsPending(true);
      await props.onPress?.();
    } finally {
      setIsPending(false);
    }
  }

  return (
    <ReactButton
      {...props}
      onPress={handlePress}
      isLoading={isPending || props.isLoading}
    />
  );
});
